<div class="min-h-screen">
  <router-outlet></router-outlet>
</div>
